import { Box, Typography } from "@mui/material";
import type { ReactNode } from "react";

type WidgetEmptyStateProps = {
  icon: ReactNode;
  title: string;
  subtitle?: string;
};

/**
 * Shared empty state for dashboard widgets (Thank You Notes, Recent Campaigns, Top Gifts).
 * Centered icon + title + subtitle, matching ProductEmptyState/CollectionEmptyState styling.
 */
const WidgetEmptyState = ({ icon, title, subtitle }: WidgetEmptyStateProps) => (
  <Box
    data-testid="widget-empty-state"
    sx={{
      display: "flex",
      flex: 1,
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      minHeight: 240,
      textAlign: "center",
      gap: 1,
      px: 2,
    }}
  >
    <Box sx={{ color: "#d4c4b8", display: "flex", "& svg": { fontSize: 48 } }}>{icon}</Box>
    <Typography sx={{ fontSize: "16px", fontWeight: 600, color: "#757575" }}>{title}</Typography>
    {subtitle && (
      <Typography sx={{ fontSize: "14px", color: "#9e9e9e", maxWidth: 260 }}>{subtitle}</Typography>
    )}
  </Box>
);

export default WidgetEmptyState;
